export default "__VITE_ASSET__Cp6RncSd__"